import * as React from 'react';
import { Header2, ModalWindow, Paragraph3 } from '@cian/ui-kit';
import { LastHopePopupCall } from '../../containers/Call/LastHopePopupCall';
import * as styles from './styles.css';

export interface ILastHopePopupProps {
  builderName: string | null;
  isOpened: boolean;
  onClose(): void;
}

export function LastHopePopup({ builderName, isOpened, onClose }: ILastHopePopupProps) {
  return (
    <ModalWindow size="XS" fixed={false} open={isOpened} onClose={onClose} width={480} height={233}>
      <div className={styles['container']}>
        <div className={styles['left']} />
        <div className={styles['right']}>
          <Header2>Позвоните застройщику, чтобы узнать ещё больше</Header2>
          <div className={styles['button']}>
            <LastHopePopupCall />
          </div>
          {builderName && <Paragraph3 color="gray60_100">Застройщик {builderName}</Paragraph3>}
        </div>
      </div>
    </ModalWindow>
  );
}
